<div class="wrapper" #wrapper>
	<div class="content">
		<div class="pass" [ngSwitch]="passLayout">
			<app-pass-card
				*ngSwitchCase="'pass'"
				[formState]="formState"
				[pass]="pass"
				[forStaff]="false"
				[forInput]="forInput"
				[isActive]="isActive"
				[forFuture]="forFuture"
				[isOpenBigPass]="true"
				[fullScreenButton]="true"
				(scaleCard)="close()"></app-pass-card>
			<app-inline-pass-card
				*ngSwitchCase="'inlinePass'"
				[pass]="pass"
				[forInput]="forInput"
				[isActive]="isActive"
				[isOpenBigPass]="true"
				[fullScreen]="true"></app-inline-pass-card>
			<app-request-card
				*ngSwitchCase="'request'"
				[request]="pass"
				[forInput]="forInput"
				[forFuture]="forFuture"
				[formState]="formState"
				[isOpenBigPass]="true"
				[fullScreenButton]="true"
				(scaleCard)="close()"></app-request-card>
			<app-inline-request-card
				*ngSwitchCase="'inlineRequest'"
				[request]="pass"
				[forInput]="forInput"
				[isOpenBigPass]="true"
				[forFuture]="forFuture"
				[fullScreen]="true"></app-inline-request-card>
		</div>
		<div class="metrics">
			<app-student-metrics></app-student-metrics>
			<app-pass-limit-info *ngIf="!forFuture" [passLimitInfo]="passLimitInfo"></app-pass-limit-info>
		</div>
	</div>
</div>
